$(document).ready( function(){
	if ($('.megamenu-trigger').length > 0 && $('.megamenu').length > 0){
	    $(document).on('click','.navigation-wrapper:not(.open) .megamenu-trigger',function(){
	    	if($(this).hasClass('on')){
		    	$('.megamenu-trigger').removeClass('on');
		    	$('.megamenu').removeClass('on');
		    }else{
		    	$('.megamenu-trigger').removeClass('on');
		    	$('.megamenu').removeClass('on');
		    	var id = $(this).data('mm-id');
		    	$(this).toggleClass('on');
		    	$('.megamenu[data-pageid="' + id + '"]').toggleClass('on');
		    }
	    });
	}
});